"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Backbone = _interopRequireDefault(require("Backbone"));

var _jquery = _interopRequireDefault(require("jquery"));

var _getPathname = _interopRequireDefault(require("crm_internal/utils/getPathname"));

var _URLSegments = _interopRequireDefault(require("crm_internal/utils/URLSegments"));

var NavigationConfirmation = _interopRequireWildcard(require("customer-data-ui-utilities/navigation/NavigationConfirmation"));

var _RouterContainer = _interopRequireDefault(require("crm_internal/containers/RouterContainer"));

var _beforeUnloadQueue = _interopRequireDefault(require("crm_internal/utils/beforeUnloadQueue"));

var PromiseHandlers = _interopRequireWildcard(require("UIComponents/core/PromiseHandlers"));

var _once = _interopRequireDefault(require("transmute/once"));

function resetSearch() {
  // v3
  (0, _jquery.default)('.nav-search-bar').val('').blur();
  (0, _jquery.default)('.inline-search').removeClass('search-input-focused-or-dropdown-open');
  (0, _jquery.default)('.nav-dropdown-menu').hide();
}

var handleNavigationOverride = function handleNavigationOverride(evt) {
  try {
    if (localStorage.getItem('crm:perf-experiment:routing:disable') === 'true') {
      return;
    }
  } catch (e) {// No-op
  }

  if (!(evt.metaKey || evt.ctrlKey)) {
    resetSearch();
  }

  var $el = (0, _jquery.default)(evt.target).closest('a');
  var isTargetBlank = $el.attr('target') === '_blank';
  var isButtonRole = $el.attr('aria-role') === 'button';

  var href = _URLSegments.default.getFragment($el.attr('href'));

  if (!(typeof href !== 'undefined' && href !== null && !(evt.metaKey || evt.ctrlKey) && !(isTargetBlank || isButtonRole))) {
    return;
  }

  if (href === _Backbone.default.history.fragment) {
    return;
  }

  evt.preventDefault(); // eslint-disable-next-line consistent-return

  return NavigationConfirmation.confirmNavigation().then(function () {
    return _RouterContainer.default.getContainer().get().navigate(href, {
      trigger: true
    });
  }).catch(PromiseHandlers.rethrowError).done();
};

var navigationOverride = (0, _once.default)(function () {
  _beforeUnloadQueue.default.addBeforeUnloadCallback(NavigationConfirmation.confirmUnload);

  var root = (0, _getPathname.default)();
  (0, _jquery.default)(document).on('click', [":not(#hs-nav-v3, #hs-nav-v4) a[href^='" + root + "']:not(.CRMLink):not(.disabled)", "#hs-nav-v3 a[href*='" + root + "']", "#hs-nav-v3 .nav-search-item-link[href*='" + root + "']"].join(', '), handleNavigationOverride);

  if (!window.hubspot) {
    // eslint-disable-next-line hubspot-dev/hubspot-is-special
    window.hubspot = {};
  }
  /* eslint hubspot-dev/hubspot-is-special: ["error",  { "allowedHubspotProperties": ["navigation"] }] */


  if (!window.hubspot.navigation) {
    window.hubspot.navigation = {};
  }

  window.hubspot.navigation.navItemListener = handleNavigationOverride;
  window.hubspot.navigation.searchResultListener = handleNavigationOverride;
});
var _default = navigationOverride;
exports.default = _default;
module.exports = exports.default;